export const SELECT_ADMIN_FINANCE_TAB = 'SELECT_ADMIN_FINANCE_TAB';

export const ADMIN_AUDIT_FINANCE_MANAGEACCOUNTS_LABEL = 'Manage Accounts';
export const ADMIN_AUDIT_FINANCE_VIEWFEES_LABEL = 'View Fees';
export const ADMIN_AUDIT_FINANCE_SETFEES_LABEL = 'Set Fees';


// WEBPACK FOOTER //
// ./src/features/finance/constants.js